export default __webpack_public_path__ + "static/media/fish.851953a4.svg";